import './header-no-login.scss'
import template from './header-no-login.tpl'
import common from '@/utils/common'
import languageObj from './header-no-login-lan.json'
const { mapState } = require('vuex')
const hostPath = require('@config/host')
const projectData = require('@/utils/projectData.json')

export default {
  template,

  name: 'header-no-login',

  computed: {
    ...mapState({
      lan: (state) => {
        return state.sys.lan
      }
    })
  },

  data () {
    return {
      LANMSG: {},
      logoImg: '',
      lanOptions: [],
      curLanguage: '' // 当前选择的语言
    }
  },

  // 实例创建后,进行默认数据处理
  created () {
    this.lanOptions = common.languageOptions()
    this.curLanguage = this.lan
    this.setLanguageMsg(this.lan)
    this.logoImg = projectData[hostPath.sysType].logo
  },

  // html挂载在页面后,进行数据初始化
  mounted () {},

  watch: {
    lan: function (n) {
      this.setLanguageMsg(n)
    }
  },

  // 方法集合
  methods: {
    // 设置语言文字
    setLanguageMsg (lan) {
      this.LANMSG = languageObj[lan]
    },

    // 语言改变时
    changeLanguage (val) {
      common.setLanguage(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/headerNoLogin/header-no-login.js